/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, Provider, Tabs as TabsCore, type TabsProps as TabsCoreProps, useContextProps } from 'react-aria-components';
import { breakpoints } from '../../constants.stylex';
import { $ } from '../../tokens.stylex';
import { TabContext } from '../tab/tab.component';

interface TabsProps extends Omit<TabsCoreProps, 'style' | 'className'> {
  /** Whether the tabs in the list are bordered. (Default: false) */
  isBordered?: boolean;
  style?: stylex.StyleXStyles;
}

const TabsContext = createContext<ContextValue<TabsProps, HTMLDivElement>>({});

const Tabs = forwardRef((props: TabsProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, TabsContext);

  const { style, children, isBordered = false, ...coreProps } = props;

  return (
    <Provider values={[
      [TabContext, { isBordered }]
    ]}>
      <TabsCore ref={ref} {...stylex.props(styles.base, isBordered && styles.withoutBorder, style)} {...coreProps}>
        {children}
      </TabsCore>
    </Provider>
  );
});

const styles = stylex.create({
  base: {
    borderBlockEndColor: $.border06,
    borderBlockEndStyle: {
      default: 'solid',
      ':is([data-orientation="vertical"])': 'none'
    },
    borderBlockEndWidth: 1,
    display: 'flex',
    flexDirection: {
      default: 'row',
      ':is([data-orientation="vertical"])': 'column'
    },
    gap: {
      default: 40,
      [breakpoints.small]: 24,
    },
    paddingInline: 20,
  },
  withoutBorder: {
    borderBlockEndStyle: 'none',
  }
});

export { Tabs, TabsContext, type TabsProps };
